import { render, staticRenderFns } from "./LocalStorageEditor.vue?vue&type=template&id=5373f220&scoped=true&"
import script from "./LocalStorageEditor.vue?vue&type=script&lang=ts&"
export * from "./LocalStorageEditor.vue?vue&type=script&lang=ts&"
import style0 from "./LocalStorageEditor.vue?vue&type=style&index=0&id=5373f220&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5373f220",
  null
  
)

export default component.exports